export default __webpack_public_path__ + "img/img01.d2144a76.png";